import { newToolFilterOAuthMcp } from "../oauth.ts";

export const zenableMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://www.zenable.io/favicons/apple-touch-icon.png",
  url: "https://mcp.zenable.app/",
  label: "Zenable",
});
